import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import state from './tripTemplates.state';
import getters from './tripTemplates.getters';
import actions from './tripTemplates.actions';
import mutations from './tripTemplates.mutations';

BaseStore.registerModule('tripTemplates', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapActions, mapMutations } = createNamespacedHelpers('tripTemplates');

export {
	mapState,
	mapGetters,
	mapActions,
	mapMutations
};